import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    loading: false,
    configObjects: {
    }
}

const ConfigReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.CONFIG_UPDATE_CONFIGOBJECTS:
            return {
                loading: true
            }
        case actionTypes.CONFIG_UPDATE_CONFIGOBJECTS_SUCCESS:
            return {
                loading: false,
                configObjects: { ...state.configObjects, ...action.payload }
            }
        default:
            return state;
    }
}

export default ConfigReducer;